/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRouteError } from 'react-router';
import { Box, Title, Image } from '@mantine/core';
import { Text } from '@components/atoms/Text';
import classes from './error-page.module.css';
import InukLogo from '@assets/images/inuk-logo.svg';
import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
	const { t } = useTranslation();
	const error: any = useRouteError();
	console.error('Error boundary : ', error);

	return (
		<Box className={classes.container} id="error-page">
			<Box className={classes.containerLogo}>
				<Image src={InukLogo} />
			</Box>
			<Title size="h1">{t('errors.oops')}</Title>
			<Text type="body1">
				<i>{error.status}</i>
			</Text>
			<Text type="body1">{t('errors.sorryMessage')}</Text>
			<Text type="body1">
				<i>{error.data || error.message}</i>
			</Text>
		</Box>
	);
};

export default ErrorPage;
